import React from 'react';
import './check-layer.css';
// import isIPadAppFunction from "../../lib/xes/common.js";
import xesBridge from 'xes-code-base/lib/libs/xes'

class checkLayer extends React.Component{
  constructor(){
    super();
    let now = new Date()
     this.state = {
      isIpad: xesBridge.isIPadAppFunction(),
      stamp: now.getMinutes()
     }
  }
  render(){
    return(
      <div>
        {
          this.state.isIpad ? 
          <iframe className="ipad-iframe" src={`${window.location.origin}/scratch/static/check-layer/check.html?version=${this.state.stamp}`} frameBorder="0"></iframe>
          :
          <iframe className="pc-iframe" src={`${window.location.origin}/scratch/static/check-layer/check.html?version=${this.state.stamp}`} frameBorder="0"></iframe>
        }
      </div>
    )
  }
}
export default checkLayer